import logo from './images/logo.png';
import logo2 from './images/logo2.png';
import image from './images/image.png';
import logo1 from './images/logo.jpg';
import temp from './images/temp.png';
import section2 from './images/section2.jpg';
import house1 from './images/house1.png';
import house2 from './images/house2.png';
import house3 from './images/house3.png';
import map from './images/map.png';

import adminbanner from './images/adminbanner.jpg';

//tabs
import ProjectsIcon from './images/Tabs/project.png';
import UsersIcon from './images/Tabs/user.png';
import BuildersIcon from './images/Tabs/builder.png';
import DashboardIcon from './images/Tabs/dashboard.png';
import NotificationIcon from './images/notificationicon.png';
import SettingsIcon from './images/settingsicon.png';
import LeadsIcon from './images/Tabs/leads.png';
import ChannelPartnersIcon from './images/Tabs/channelpartner.png';

//Aminities
import bedking from './images/Aminities/bedking.png';
import books from './images/Aminities/books.png';
import car from './images/Aminities/car.png';
import shield from './images/Aminities/shield.png';
import playground from './images/Aminities/playground.png';
import stethoscope from './images/Aminities/stethoscope.png';
import swimming from './images/Aminities/swimming.png';
import homelove from './images/Aminities/homelove.png';


import DashboardIcon1 from './images/dashboardicon.png';
import loginbackground from './images/loginbackground.jpg';

//Feed
import feed1 from './images/Feed/feed1.jpg';
import feed2 from './images/Feed/feed2.jpg';
import feed3 from './images/Feed/feed3.jpg';
import feed4 from './images/Feed/feed4.jpg';
import feed5 from './images/Feed/feed5.jpg';
import nodata from './images/nodata.jpg';

import UploadIcon from './logo/upload.png';







//Contact Us
import addressimage from './images/ContactUs/addressimage.png';
import emailimage from './images/ContactUs/emailimage.png';
import mobileimage from './images/ContactUs/mobileimage.png';


import person from './images/person.jpg';

import More from './images/more.png';

import Aboutus1 from './images/aboutus1.png';
import home1 from './images/home1.png';

import galleryimage from './images/galleryimage.jpg';

import dprlogo from './images/dprlogo.png';
import dprwhite from './images/dpr_white.png';


export { logo, image, logo1 , temp , section2 , house1 , house2 , house3 , map , Aboutus1, home1, logo2, person , galleryimage, More};


export {adminbanner, dprlogo, dprwhite};

export const AminitiesImages = {
    bedking,
    books,
    car,
    shield,
    playground,
    stethoscope,
    swimming,
    homelove,
};

// Tabs
export const TabsIcons = {
    ProjectsIcon,
    UsersIcon,
    BuildersIcon,
    DashboardIcon,
    NotificationIcon,
    SettingsIcon,
    LeadsIcon,
    ChannelPartnersIcon,
};

export { DashboardIcon1 , loginbackground};

//Feed
export const FeedImages = {
    feed1,
    feed2,
    feed3,
    feed4,
    feed5,
    nodata,
};

export const ContactUsImages = {
    addressimage,
    emailimage,
    mobileimage,
};


export {UploadIcon};